import '../../App.css';
import { Menubar } from 'primereact/menubar';
import { Outlet, useNavigate } from 'react-router-dom';
import logoImg from '../../assets/images/logo.png';
import mobileLogoImg from '../../assets/images/logoHeader.svg';
import { useSigner } from 'wagmi';
import { ReactComponent as Sun } from "../../assets/images/Sun.svg";
import { ReactComponent as Moon } from "../../assets/images/Moon.svg";
import { useEffect, useState } from 'react';
import ConnectBtn from '../../component/ConnectBtn';

function RoutingLayout() {

    const [checkBoxVal, setCheckBoxVal] = useState<boolean>(false);
    const [selectedTheme, setSelectedTheme] = useState(localStorage.getItem("selectedTheme"));

    useEffect(() => {
        const selectedTheme = localStorage.getItem("selectedTheme");
        setSelectedTheme(selectedTheme);
        if (selectedTheme === "dark") {
            setDarkMode();
            setCheckBoxVal(true);
        }
    }, [])

    // const { isConnected } = useAccount()
    const { data: signer, isError, isLoading } = useSigner();
    const navigate = useNavigate();
    function navigateToPage(string: any) {
        navigate(string);
    }

    const setDarkMode = () => {
        console.log("dark");
        document.querySelector("body")?.setAttribute("data-theme", "dark");
        localStorage.setItem("selectedTheme", "dark");
        setSelectedTheme(selectedTheme);
    }

    const setLightMode = () => {
        console.log("light");
        document.querySelector("body")?.setAttribute("data-theme", "light");
        localStorage.setItem("selectedTheme", "light");
        setSelectedTheme(selectedTheme);
    }

    const toggleTheme = (e: any) => {
        setCheckBoxVal(e.target.checked)
        if (e.target.checked) setDarkMode()
        else setLightMode()
    }

    const items = [
        {
            label: 'Liquidity Manager',
            // icon: 'pi pi-fw pi-file',
            command: () => { navigateToPage('/') },
        },
        {
            label: 'Quant Strategies',
            // icon: 'pi pi-fw pi-file',
            command: () => { navigateToPage('/quant') },
        },
        // {
        //     label: 'Discover',
        //     // icon: 'pi pi-fw pi-file',
        //     command: () => { navigateToPage('discover') },
        // },
        {
            label: 'Bridges',
            // icon: 'pi pi-fw pi-pencil',
            // url: 'https://bridge.mantle.xyz/',
            target: "_blank",
            items: [
                {
                    label: 'Mantle Network',
                    // icon: 'pi pi-fw pi-trash',
                    url: 'https://bridge.mantle.xyz/',
                    target: "_blank"
                },
                {
                    label: 'Manta Pacific',
                    // icon: 'pi pi-fw pi-trash'
                    url: 'https://pacific-bridge.manta.network/',
                    target: "_blank"
                },
                {
                    label: 'Symbiosis',
                    // icon: 'pi pi-fw pi-trash'
                    url: 'https://app.symbiosis.finance/swap?chainIn=Ethereum&tokenIn=ETH&tokenOut=ETH',
                    target: "_blank"
                },
                // {
                //     label: 'Router',
                //     url: 'https://texchange.routerprotocol.com/swap',
                //     target: "_blank"
                //     // icon: 'pi pi-fw pi-trash'
                // },
            ],
        }
    ];
    const start = <> <img alt="logo" src={logoImg} height="40" className="mr-2 crsr_pntr notMobileDevice" onClick={() => { navigateToPage('/') }} />
    <img alt="logo" src={mobileLogoImg} height="40" className="mr-2 crsr_pntr mobileDevice" onClick={() => { navigateToPage('/') }}></img></>;
    const end =  <ConnectBtn/>;
    const toggleButton = <div className='dark_mode'>
        <input
            className='dark_mode_input'
            type='checkbox'
            id='darkmode-toggle'
            checked={checkBoxVal}
            onClick={toggleTheme}
        />
        <label className='dark_mode_label' htmlFor='darkmode-toggle'>
            <Sun />
            <Moon />
        </label>
    </div>

    const endButton = <><div className='d-flex'><div className='mr_mob_20'>{end}</div><div>{toggleButton}</div></div> </>


    return (
        <>
            {/* <div className='header_warning'>
                <div className='header_warning_font'>
                    <img src={alertTriangleImg} className='left_wrgn_alrt' alt='alert'/>
                    <span>MVP TESTING RISK NOTICE</span>
                    <img src={alertTriangleImg} className='left_wrgn_alrt' alt='alert'/>
                    </div>
                <div>Rivera contracts are NOT audited yet. You may lose ALL funds deposited into Rivera-powered strategy vaults.</div>
            </div> */}
            <div className="card bg_gray">
                <Menubar model={items} start={start} end={endButton} className='custom-container' />
            </div>
            {/* {signer ? <><div className="main">
                <Outlet />
            </div></> : <></>} */}
            <div className="main">
                <Outlet />
            </div>

        </>
    )
}

export default RoutingLayout;